import { Role } from './role.entities';

export interface AccessRightsResponse {
  active: boolean;
  canAdd: Role[];
  canDelete: Role[];
  canInvite: Role[];
  permissions: { actions: PermissionsValues; module: PermissionsNames }[];
  role: Role;
}

export type Permissions = Map<PermissionsNames, PermissionsValues>;

export enum PermissionsNames {
  Wallets = 'wallets',
  Activity = 'transactions',
  Organizations = 'organizations',
  Users = 'accounts',
  Cards = 'cards',
  Settings = 'settings',
}

export enum PermissionConditionsNames {
  Wallets = 'wallets_list',
  Activity = 'cardtransactions_list',
  Organizations = 'organizations_list',
  Users = 'accounts_list',
  Cards = 'cards_list',
}

export type PermissionCollection = [PermissionsNames, PermissionConditionsNames];
export type PermissionsValues =
  | WalletsPermissions
  | TransactionPermissions
  | OrganizationsPermissions
  | UsersPermissions
  | CardPermissions
  | SettingsPermissions;

export interface WalletsPermissions {
  close_wallet?: boolean;
  topups_all?: boolean;
  topups_export?: boolean;
  topups_list?: boolean;
  wallet_addmember?: boolean;
  wallet_create?: boolean;
  wallet_delmember?: boolean;
  wallet_edit?: boolean;
  wallet_exchange?: boolean;
  wallet_payout?: boolean;
  wallet_topup?: boolean;
  wallet_transfer?: boolean;
  wallets_all?: boolean;
  wallets_list?: boolean;
}

export interface TransactionPermissions {
  cardtransactions_all?: boolean;
  cardtransactions_export?: boolean;
  cardtransactions_list?: boolean;
  transactions_all?: boolean;
  transactions_list?: boolean;
  wallettransactions_all?: boolean;
  wallettransactions_export?: boolean;
  wallettransactions_list?: boolean;
}

export interface OrganizationsPermissions {
  fee_info?: boolean;
  organization_edit?: boolean;
  organization_addmember?: boolean;
  organization_delmember?: boolean;
  organizations_list?: boolean;
  organization_status?: boolean;
  organization_create?: boolean;
}

export interface UsersPermissions {
  accounts_list?: boolean;
  accounts_profile_currency?: boolean;
  accounts_status?: boolean;
  invite_account?: boolean;
  invite_form?: boolean;
  role_change?: boolean;
}

export interface CardPermissions {
  card_block?: boolean;
  card_close?: boolean;
  card_create?: boolean;
  card_edit?: boolean;
  card_limit?: boolean;
  card_pan?: boolean;
  card_unblock?: boolean;
  cards_all?: boolean;
  cards_list?: boolean;
}

export interface SettingsPermissions {
  currency_list?: boolean;
  fx_rates?: boolean;
}
